import store from 'app/store/store';
import { ACADEMIC_SESSION_STATUS, COURSE_TYPES } from './constants/course';
import { isTeacher } from './user';

export function isCourseEditable(course) {
  return course?.course_template_type === COURSE_TYPES.TEMPLATE_2 || course?.type === COURSE_TYPES.TEMPLATE_2 || course?.type === COURSE_TYPES.NO_REFERENCED;
}

export function getIsCourseReferenced(course) {
  return course?.type === COURSE_TYPES.REFERENCED;
}

export function getIsCourseTemplate1(course) {
  return course?.type === COURSE_TYPES.TEMPLATE_1;
}

export function getGuidCourseByTemplate(course) {
  return course && getIsCourseReferenced(course) ? course.guid : null;
}

export function getTeacherAvatar(item, course) {
  if (course.users && course.users.length > 0) {
    let teacher = course.users.filter((user) => item?.created_by === user.person_guid);
    if (teacher && teacher.length > 0) return teacher[0].avatar;
  }
}

export function getTeacherName(item, course) {
  if (course.users && course.users.length > 0) {
    let teacher = course.users.filter((user) => item?.created_by === user.person_guid);
    if (teacher && teacher.length > 0) return teacher[0].name + ' ' + teacher[0].lastname;
  }
}

export function getCourseGuid(course) {
  return course.course_template_type === COURSE_TYPES.TEMPLATE_2 ? course.course_template_guid : course.guid;
}

export function isEditorialCourse(course) {
  return course.type === COURSE_TYPES.TEMPLATE_1 || course.course_template_type === COURSE_TYPES.TEMPLATE_1;
}

export function getCustomizedBy(course, currentUser) {
  const schoolAdmins = store.getState()?.users?.school_admins?.map((admin) => admin.guid) || [];

  if (!course?.users && !currentUser?.guid) return null;
  const users = course?.users;
  if (!users || users.length === 0) return [currentUser.guid];
  return getTeachersGuid(course).concat(schoolAdmins);
}

export function getTeachersGuid(course) {
  return course?.users?.filter((user) => isTeacher(user)).map((teacher) => teacher.person_guid);
}

export function getGuidCourseProgram(course) {
  if (course.type === COURSE_TYPES.TEMPLATE_1) return course.guid;
  if (course.type === COURSE_TYPES.TEMPLATE_2 || course.type === COURSE_TYPES.NO_REFERENCED) return course.course_template_guid;
  if (course.type === COURSE_TYPES.REFERENCED) return course.program_guid;
}

export function isCourseReadOnly(course) {
  return course?.academic_session?.status === ACADEMIC_SESSION_STATUS.PAST;
}

export function isSchoolProgram(course) {
  return course?.is_school_program === true;
}

export function getShowLastNameFirst(course) {
  return Boolean(course?.studentGradebook?.config?.show_last_name_first);
}

export function getOrderBy(course) {
  return course?.studentGradebook?.config?.order_by || 'name';
}

/**
 * A module/section is accessible unless the backend explicitly marks it as
 * blocked with a falsy is_accessible (0, "0" or false). A missing field
 * (undefined/null) is treated as accessible. The value is normalised because
 * the backend is not consistent across endpoints (numeric on some, boolean on
 * others), which is why plain `!== 0` let blocked submodules slip through. See
 * TAN-9508.
 */
export function isModuleAccessible(module) {
  const value = module?.is_accessible;
  if (value === undefined || value === null) return true;
  return Boolean(Number(value));
}

/**
 * A module/section shows the "Coming soon" (draft) label only when it is
 * accessible AND still in draft status. A blocked module (is_accessible falsy)
 * is gated via isModuleAccessible and shown locked — never as a draft. See
 * TAN-9508.
 */
export function isModuleDraft(module) {
  return isModuleAccessible(module) && module?.status === 'draft';
}

/**
 * Students never see blocked (is_accessible falsy) nor draft (status === 'draft')
 * modules/sections. Teachers keep seeing both: blocked ones locked, drafts with
 * a "Coming soon" label. See TAN-9508.
 */
export function isModuleVisibleForStudent(module) {
  return isModuleAccessible(module) && module?.status !== 'draft';
}
